export type FrontendLogLevel = 'DEBUG' | 'INFO' | 'WARNING' | 'ERROR' | 'CRITICAL';

interface LogPayload {
  level: FrontendLogLevel;
  message: string;
  url?: string;
  user_agent?: string;
  stack?: string;
  meta?: Record<string, unknown>;
  timestamp?: string;
}

const postLog = async (payload: LogPayload) => {
  try {
    await fetch((process.env.REACT_APP_API_BASE_URL || window.location.origin.replace(':3000', ':8000').replace(':80', ':8000')) + '/logs/frontend', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
      mode: 'cors',
      credentials: 'omit',
    });
  } catch {}
};

const baseLog = (level: FrontendLogLevel, message: string, meta?: Record<string, unknown>) => {
  const payload: LogPayload = {
    level,
    message,
    url: window.location.href,
    user_agent: navigator.userAgent,
    timestamp: new Date().toISOString(),
    meta,
  };
  // mirror to console
  const fn = level === 'ERROR' || level === 'CRITICAL' ? console.error : level === 'WARNING' ? console.warn : console.log;
  fn('[FE]', message, meta);
  // send to backend
  postLog(payload);
};

export const feLogger = {
  info: (msg: string, meta?: Record<string, unknown>) => baseLog('INFO', msg, meta),
  warn: (msg: string, meta?: Record<string, unknown>) => baseLog('WARNING', msg, meta),
  error: (msg: string, err?: unknown, meta?: Record<string, unknown>) => {
    const stack = err instanceof Error ? err.stack : undefined;
    baseLog('ERROR', msg, { ...(meta || {}), error: err instanceof Error ? err.message : err });
    if (stack) postLog({ level: 'ERROR', message: msg, stack });
  },
  debug: (msg: string, meta?: Record<string, unknown>) => baseLog('DEBUG', msg, meta),
};
